import React, { memo } from 'react';
import { suggestionsContainerScroll } from './styles';

type SuggestionsModalContainerProps = {
  containerRef: React.Ref<HTMLDivElement>;
  className: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
};

export const SuggestionsModalContainer = memo<SuggestionsModalContainerProps>(
  ({ containerRef, className, style, children }) => (
    <div ref={containerRef} style={style} className={className} data-qa="suggestions-container">
      <div className={suggestionsContainerScroll}>{children}</div>
    </div>
  ),
);

SuggestionsModalContainer.displayName = 'SuggestionsModalContainer';
